import { RoleName } from "app/dal/generated/models/security/role-name";
import { RoleDto } from "app/dal/generated/models/security/role-dto";
import { FeaturePermission } from "./feature-permission";

export const roleLabel: Record<RoleName, string> = {
    [RoleName.Administrator]: "Administrator",
    [RoleName.BillingAdministrator]: "Billing Administrator",
    [RoleName.CommitteeMember]: "Committee Member",
    [RoleName.Editor]: "Editor",
    [RoleName.Viewer]: "Viewer",
};

// TODO Fetch from backend instead of hard coding here to reduce duplication
// In meantime, keep in sync with StandardRole.cs
export const rolePermissions: Record<RoleName, FeaturePermission[]> = {
    [RoleName.Administrator]: Object.values(FeaturePermission).filter(
        (e) => e !== FeaturePermission.None,
    ),
    [RoleName.BillingAdministrator]: [
        FeaturePermission.PlatformAccess,
        FeaturePermission.MemberRead,
        FeaturePermission.MemberBillingRead,
        FeaturePermission.MemberBillingWrite,
        FeaturePermission.EnsembleRead,
        FeaturePermission.EnsembleWrite,
    ],
    [RoleName.CommitteeMember]: [
        FeaturePermission.PlatformAccess,
        FeaturePermission.AssetRead,
        FeaturePermission.AssetWrite,

        FeaturePermission.ScoreRead,
        FeaturePermission.ScoreWrite,

        FeaturePermission.MemberRead,
        FeaturePermission.MemberWrite,
        FeaturePermission.MemberDetailRead,
        FeaturePermission.MemberDetailWrite,

        FeaturePermission.MemberBillingRead,

        FeaturePermission.EnsembleRead,
        FeaturePermission.EnsembleWrite,

        FeaturePermission.ConcertRead,
        FeaturePermission.ConcertWrite,

        FeaturePermission.ContactsRead,
        FeaturePermission.ContactsWrite,

        FeaturePermission.MailingListRead,
        FeaturePermission.MailingListWrite,
        FeaturePermission.MailingListGlobalSend,
    ],
    [RoleName.Editor]: [
        FeaturePermission.PlatformAccess,
        FeaturePermission.AssetRead,
        FeaturePermission.AssetWrite,

        FeaturePermission.ScoreRead,
        FeaturePermission.ScoreWrite,

        FeaturePermission.MemberRead,
        FeaturePermission.MemberWrite,
        FeaturePermission.MemberDetailRead,
        FeaturePermission.MemberDetailWrite,

        FeaturePermission.EnsembleRead,
        FeaturePermission.EnsembleWrite,

        FeaturePermission.ConcertRead,
        FeaturePermission.ConcertWrite,

        FeaturePermission.ContactsRead,
        FeaturePermission.ContactsWrite,
    ],
    [RoleName.Viewer]: [
        FeaturePermission.PlatformAccess,
        FeaturePermission.AssetRead,

        FeaturePermission.ScoreRead,

        FeaturePermission.MemberRead,

        FeaturePermission.EnsembleRead,

        FeaturePermission.ConcertRead,
    ],
};

export class Role implements RoleDto {
    public id: string;
    public name: RoleName;

    public constructor(role: RoleDto) {
        this.id = role.id;
        this.name = role.name;
    }

    public get label() {
        return roleLabel[this.name];
    }

    public get permissions() {
        return rolePermissions[this.name];
    }
}
